import { Toaster as Sonner, toast } from "sonner"

// Flat, neutral notifications: one surface, hairline border, no tinted backgrounds.
const Toaster = ({ ...props }) => (
  <Sonner
    theme="dark"
    className="toaster group"
    toastOptions={{
      unstyled: true,
      classNames: {
        toast:
          "flex items-center gap-3 w-[340px] px-4 py-3 rounded-md border border-white/[0.1] bg-[#121217] text-zinc-100 text-sm shadow-none",
        title: "text-sm font-medium text-zinc-100",
        description: "text-xs text-zinc-400",
        icon: "hidden",
        actionButton: "ml-auto h-7 px-2.5 rounded-md text-xs font-medium bg-primary text-white",
        cancelButton: "ml-auto h-7 px-2.5 rounded-md text-xs border border-white/[0.12] text-zinc-300",
        error: "border-l-2 border-l-red-500",
        success: "border-l-2 border-l-primary",
        warning: "border-l-2 border-l-primary",
        info: "border-l-2 border-l-zinc-500",
      },
    }}
    {...props} />
);

export { Toaster, toast }
